import { createContext, useContext, useState, useCallback } from 'react';
import translations from '../translations';

const LanguageContext = createContext(null);

const LANGUAGES = [
  { code: 'ja', label: '日本語', flag: 'jp' },
  { code: 'pt', label: 'Português', flag: 'br' },
  { code: 'en', label: 'English', flag: 'us' },
];

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(
    () => localStorage.getItem('prc_lang') || 'ja'
  );

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    localStorage.setItem('prc_lang', lang);
  }, []);

  const t = useCallback((key, params) => {
    let text = translations[language]?.[key] || translations.ja[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export { LANGUAGES };
